import React, { CSSProperties, ReactNode } from "react";
import './column.css';

interface ColumnProps extends React.PropsWithChildren<React.ComponentProps<'div'>>{
}

const Column:React.FC<ColumnProps> = ({ children, style, ...props }) => {
    return (
        <div className="dry-design-col" style={{...style}} {...props}>
            {children}
        </div>
    )
}

export default Column;